import { Stack } from "@mui/material";

const Item = ({
  minWidth,
  maxWidth,
  justifyContent = "flex-start",
  itemMaxWidth = "100%",
  secondItemMaxWidth = "100%",
  isNameField,
}: {
  minWidth: string;
  maxWidth: string;
  justifyContent?: "space-between" | "center" | "flex-start" | "flex-end";
  itemMaxWidth?: string;
  secondItemMaxWidth?: string;
  isNameField?: boolean;
}) => {
  return (
    <Stack
      alignItems={justifyContent}
      minWidth={minWidth}
      maxWidth={maxWidth}
      justifyContent={"center"}
      width="100%"
      padding="0 16px"
      gap="8px"
    >
      <span
        style={{
          borderRadius: "8px",
          height: "16px",
          width: "100%",
          maxWidth: itemMaxWidth,
          backgroundColor: "#ECECEC",
        }}
      />
      {isNameField && (
        <span
          style={{
            borderRadius: "8px",
            height: "16px",
            width: "100%",
            maxWidth: secondItemMaxWidth,
            backgroundColor: "#ECECEC",
          }}
        />
      )}
    </Stack>
  );
};

export const EmptyRoleRow = () => {
  return (
    <Stack
      className={"no-drag"}
      sx={{
        flexGrow: 1,
        flexDirection: "row",
        alignItems: "center",
        padding: "14px 0",
        border: "1px solid #E0E0E0",
        borderRadius: "8px",
      }}
    >
      <Item
        maxWidth={"48%"}
        minWidth={"120px"}
        itemMaxWidth="144px"
        secondItemMaxWidth="172px"
        isNameField={true}
      />
      <Item maxWidth={"20%"} minWidth={"100px"} itemMaxWidth={"72px"} />
      <Item
        maxWidth={"12%"}
        minWidth={"124px"}
        justifyContent="flex-end"
        itemMaxWidth={"40px"}
      />
      <Item
        maxWidth={"12%"}
        minWidth={"144px"}
        justifyContent="flex-end"
        itemMaxWidth={"40px"}
      />
      <Item
        maxWidth={"12%"}
        minWidth={"104px"}
        justifyContent="flex-end"
        itemMaxWidth={"40px"}
      />
    </Stack>
  );
};
